import httpService from "./httpService";

export default {
  findById(id) {
    return httpService.get("vbInComingDocCopy/findById/" + id);
  },

  create(form) {
    return httpService.post("vbInComingDocCopy", form
    );
  },

  saveCopy(form) {
    return httpService.post("vbInComingDocCopy/saveCopy", form)

  },
  delete(id) {
    return httpService.delete("vbInComingDocCopy/" + id
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingDocCopyService.js